import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MdLocationOn from 'react-icons/lib/md/location-on';
import _ from 'lodash';

import { fetchLocations, fetchGisObjects } from '../../actions/project_actions';
import GMap from './gmap';

const MAP_STYLE = {
  height: '800px'
}

class ProjectLocations extends Component {
  
  componentDidMount() {
    if (this.props.fetch) this.props.fetchLocations(this.props.projectId);
    this.props.fetchGisObjects(this.props.projectId);
  }

  constructor(props) {
    super(props);

    this.handleMapLoad = this.handleMapLoad.bind(this);
    this.setActiveIndex = this.setActiveIndex.bind(this);

    this.state = {
      activeIndex: 0,
    };
  }

  handleMapLoad(map, bounds) {
    this._mapComponent = map;
    map && map.fitBounds(bounds);
  }

  setActiveIndex(index) {
    return () => this.setState({ activeIndex: index });
  }

  renderSection(locations, projectId, gisObjects) {
    const { activeIndex } = this.state;
    const location = locations[activeIndex];

    var projectType, linkToGis = '';
    var merged = [];

    if (locations[0].division === 'Public Buildings') {
      projectType = 'PiStrProj';

      _.map(gisObjects, function (item) {
         if (item !== null && item.ddC_Address !== null)
        item.ddC_Address = item.ddC_Address.trim();
      });

      // ddC_Address is the only common field to join from db
      merged = _.map(locations, function (item) {
        return _.assign(item, _.find(gisObjects, ['ddC_Address', item.address2]));
      });
    }

    if (locations[0].division === 'Infrastructure' || locations[0].division === 'Infrastructures') {
      projectType = 'PiIfrProj';

      //1st element since there are only distinct records: select objectid, PROJECTID, COUNT(*) from [ddc].[AB_GIFRPROJECTS_TRANSFER] group by PROJECTID, objectid having COUNT(*) > 1
      if(locations.length > 0 && gisObjects.length > 0)
        {
          locations[0].objectId = gisObjects[0].objectid;
          merged = locations;
        }
    }

    const locationList = merged.map((location, i) => {
      const key = `loc-${location.id}`;
      const className = activeIndex === i ? 'active' : null;

      // PB
      if (location.objectid !== undefined && location.objectid !== null && projectType === 'PiStrProj')
        linkToGis = 'http://ddcgisintra/PrInfMp/Default.aspx?ProjectID=' + projectId + '&ObjectID=' + location.objectid + '&ProjType=' + projectType;

      // Infra  
      if (location.objectId !== undefined && location.objectId !== null && projectType === 'PiIfrProj')
        linkToGis = 'http://ddcgisintra/PrInfMp/Default.aspx?ProjectID=' + projectId + '&ObjectID=' + location.objectId + '&ProjType=' + projectType;

      return (
        <li key={key} className={className} onClick={this.setActiveIndex(i)}>
          <span><MdLocationOn size={20} color='#8492a6' /></span>
          <div className="loc-name">
            {location.description}{location.zipCode ? ',' : ''} {location.zipCode}
          </div>
          {location.borough && <div><strong>Borough:</strong> {location.borough}</div>}
          {location.ownerName && <div><strong>Owner Name:</strong> {location.ownerName}<br /></div>}
          {location.nyctaxlot && <div><strong>NYC Tax lot:</strong> {location.nyctaxlot}<br /></div>}

          <div className="row margin-top-075">
            <div className="col s6 m3 l6 padding-left-0 padding-right-0">
              {location.address !== null
                ?
                <form action="http://maps.google.com/maps" method="get" target="_blank">
                  <input type="hidden" name="saddr" value={undefined} />
                  <input type="hidden" name="daddr" value={location.address} />
                  <div>
                    <button className="btn-save margin-left-0" type="submit">Get directions</button>
                  </div>
                </form>
                : ''}
            </div>
            {linkToGis !== ''
              ? <div className="col s6 m3 l6 padding-left-0 padding-right-0">
                <div>
                  <a href={linkToGis} target="_blank" rel="noopener noreferrer"><button className="btn-save margin-left-0">Gis info</button></a>
                </div>
              </div>
              : ''}
          </div>

        </li>
      );
    });

    return (
      <div>
        <div className="col s12 l4" id="locationScroll">
          <ul className="location-list">
            {locationList}
          </ul>
        </div>
        <div className="col s12 l8">
          <div style={MAP_STYLE}>
            <GMap
              googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyAmfApFvvmRwOGnSv_1XIy0Z7UMac5vW5w"
              loadingElement={<div className="boxed" style={MAP_STYLE}>Loading ...</div>}
              containerElement={<div className="boxed" style={MAP_STYLE}></div>}
              mapElement={<div style={MAP_STYLE}></div>}
              onMapLoad={this.handleMapLoad}
              coordinates={location.geometryCoordinates}
              geometryType={location.geometryType}
              activeIndex={activeIndex}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { locations, projectId, gisObjects } = this.props;

    return (
      <div id="locations" className="row-wide project-locations">
        <div className="col s12">
          <h4 className="bar-bottom">
            <span><MdLocationOn size={20} /></span> Locations
          </h4>
        </div>
        {locations.length
          ? this.renderSection(locations, projectId, gisObjects)
          : <div className="col s12">This project has no location entries yet.</div>}
      </div>
    );
  }

}

ProjectLocations.propTypes = {
  fetch: PropTypes.bool,
  projectId: PropTypes.string.isRequired,
  locations: PropTypes.array.isRequired,
  fetchLocations: PropTypes.func.isRequired,
  fetchGisObjects: PropTypes.func.isRequired,
  gisObjects: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    projectId: ownProps.projectId,
    locations: state.projectsStore.locations,
    gisObjects: state.projectsStore.gisObjects,
  };
}

export default connect(mapStateToProps, { fetchLocations, fetchGisObjects })(ProjectLocations);